module.exports = __webpack_public_path__ + "static/img/aepic-11.3240675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/aepic/aepic-11.jpg
// module id = t4lg
// module chunks = 51